export default __webpack_public_path__ + "static/media/security-settings.729946b3.png";